/*****************************************************************************
 *   © Copyright 2021   Quantitative Software Management, Inc.               *
 *              --  All rights reserved.  --                                 *
 *   Unpublished -- rights reserved under the Copyright Laws                 *
 *   of the United States.                                                   *
 *                                                                           *
 *   This computer software is protected by trade secret, copyright law,     *
 *   and international treaties and contains proprietary and confidential    *
 *   trade secrets of Quantitative Software Management, Inc.  Unauthorized   *
 *   use, reproduction, or distribution of this program or any portion of    *
 *   it will result in severe civil or criminal penalties and will be        *
 *   prosecuted to the full extent of the law.                               *
 *                                                                           *
 *   Use, duplication, or disclosure by the Government is subject to         *
 *   restrictions as set forth in                                            *
 *      (i) a license agreement incorporated in the contract,                *
 *      (ii) the definition of "restricted rights" in paragraph (c)(1)(ii)   *
 *           of DFARS 252.227-7013 (1988), and                               *
 *      (iii) the definition of "restricted rights" in paragraph (a) of      *
 *            FAR 52.227-14, Alt III (Jun 1987) or                           *
 *      (iv) FAR 52.227-19 (Jun 1987), as applicable.                        *
 *   For purposes of the FAR, this software shall be deemed to               *
 *   be "unpublished" and licensed with disclosure prohibitions.             *
 *   Contractor/Manufacturer is   Quantitative Software Management, Inc.     *
 *                                                                           *
 *****************************************************************************/

import {
  Component,
  ViewEncapsulation,
  Injectable,
  ViewChild,
  OnInit,
  TemplateRef,
  ElementRef,
  HostListener,
  ChangeDetectorRef
} from '@angular/core';
import { Location } from '@angular/common';
import { ActivatedRoute, Router } from '@angular/router';
import { ProjectService } from './services/Project.Service';
import { AppConstants } from './app.constants';
import { DialogRef, DialogService } from '@progress/kendo-angular-dialog';
import { DomSanitizer, SafeResourceUrl, Title } from '@angular/platform-browser';
import { UtilityService, ApplicationType } from './services/Utility.Service';
import { LookupService } from './services/Lookup.Service';
import { AuthorizationService } from './services/Authorization.Service';
import { UserView } from './Models/UserView';
import { LoadingService } from './services/loading.service';
import VersionInfo from '../../package.json';
import { Subscription } from 'rxjs';

@Component({
  encapsulation: ViewEncapsulation.None,
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss']
})

@Injectable()
export class AppComponent implements OnInit {
  title = 'app';
  public isContingencyDashboard: boolean = false;
  public hideNav: boolean = false;
  public showLoading: boolean = false;
  public showDropdown: boolean = false;
  public loadingClass;
  public WebAppName = `/${AppConstants.WEBAPP_NAME}`;
  public userView: UserView = new UserView();
  @ViewChild('aspxIframeApp', { static: false }) windowContents: TemplateRef<any>;
  @ViewChild('appLoading', { static: false }) appLoadingRef: ElementRef<any>
  private aspxIframeSrcApp: SafeResourceUrl;
  public aspxIframeHeight: number = 147;
  public aspxIframeWidth: number = 400;
  public userIsAuthenticated = false;
  public accessAllowed: boolean = true;
  public get showTopMenuItems(): boolean {
    return this.userIsAuthenticated && this.accessAllowed;
  }
  public version: string = VersionInfo.version;
  public currentYear: number = new Date().getFullYear();
  public isErrorPage: boolean = false;

  constructor(private activatedRoute: ActivatedRoute,
    private router: Router,
    private projectService: ProjectService,
    private sanitizer: DomSanitizer,
    private dialogService: DialogService,
    private utilityService: UtilityService,
    private lookupService: LookupService,
    private authservice: AuthorizationService,
    private loadingService: LoadingService,
    private cdr: ChangeDetectorRef,
    private location: Location
  ) {
    this.id = new Date();

  }
  id: any;
  openDialog: DialogRef = null;
  @HostListener('window:message', ['$event'])
  onMessage(event: MessageEvent): void {
    switch (event.data.subject) {
      case 'clickFromProjectList':
        this.router.navigate([event.data.link]);
        break;

      case 'clickFromAspxPage':
        this.loadingService.ShowLoading.next(true);
        if (event.data.isProjectLink) {
          let route = '/project/' + event.data.message;
          this.router.navigate([route]);
        }

        else {
          this.utilityService.NavigateToAspx(event.data.message);
        }
        break;

      case 'showAspxPage':
        let messageParm = event.data.href;
        if (messageParm === "LoginToSelf") {
          this.utilityService.errorService.NavigateToLogin();
        }
        else if (messageParm) {
          this.utilityService.errorService.NavigateToAspx(messageParm);
        }
        break;

      case 'navigateToUrl':
        this.router.navigateByUrl(event.data.href);
        break;

      case 'navigateToLogin':
        this.utilityService.errorService.NavigateToLogin();
        break;

      case 'pushClientErrorList':
        let theError = new Error(event.data.errMessage);
        theError.name = event.data.errName;
        theError.stack = event.data.errStack;
        theError['url'] = event.data.errUrl;
        theError['Timestamp'] = event.data.errTimestamp;
        this.utilityService.errorService.ClientErrorList.push(theError);
        break;

      case 'showLoading':
        let shouldShow = event.data.shouldShow;
        this.loadingService.ShowLoading.next(shouldShow);
        break;
    }
  }

  openAspxIFrame: DialogRef = null;
  OpenEmailNotification() {
    let subscription: Subscription = this.utilityService.errorService.currentMessage.subscribe(
      msg => {
        if (msg.subject === AppConstants.ERROR_NAVIAGATION_MSG && this.openAspxIFrame) {
          if (this.openAspxIFrame) {
            this.openAspxIFrame.close();
          }
        }
      });
    let url: string = this.WebAppName + "/Views/MyAccount/EmailNotifications.aspx";
    this.aspxIframeSrcApp = this.sanitizer.bypassSecurityTrustResourceUrl(url);
    this.aspxIframeHeight = 250;
    this.aspxIframeWidth = 400;
    this.openAspxIFrame = this.dialogService.open({
      title: 'Manage Email Notifications',
      content: this.windowContents,
      height: 300,
      width: 480,
      cssClass: 'overflow-hidden'
    });

    this.openAspxIFrame.result.subscribe(  //assume any result, then complete
      {
        complete: () => {
          this.openAspxIFrame = null;
          subscription.unsubscribe(); //
          subscription = null; //needed?  or is GC enough?
        }
      }
    );

  }
  previousUrl: string = null;
  ngOnInit() {
    this.utilityService.popupChecks.add(
      (url: string, previousUrl: string) => {
        let shouldClose = (url !== previousUrl);
        return shouldClose;
      });
    this.loadingService.ShowLoading.subscribe(x => {
      this.showLoading = x;
      this.cdr.detectChanges();
    });
    let messagePosted = false;
    this.location.onUrlChange(url => {
      let routingUrl = url.replace("/qsmcollab/", "/");//is it guaranteed to be a relative url?
      this.closePopups(url);
      if (window.frameElement) {
        this.hideNav = true;
        let isTemplatePage = url.includes('/qsmcollab/template/');
        if (!isTemplatePage && routingUrl !== '/') {
          if (!messagePosted) {
            messagePosted = true;
            top.postMessage({ subject: "navigateToUrl", href: routingUrl }, "/");
          }
        }
      }
      let ind: number = url.indexOf('?');
      let parms = url.substr(ind + 1);
      let parmArray = parms.split('&');
      parmArray.forEach(params => {
        let i: number = params.indexOf('=');
        let key = params.substr(0, i);
        let value = params.substr(i + 1);
        if (key === "strategy" && value === "contingency") {
          this.isContingencyDashboard = true;
        }
        else {
          this.isContingencyDashboard = false;
        }
      });
      if (routingUrl != '/' && !routingUrl.startsWith('/error')) {
        this.loadingService.ShowLoading.next(true);
        this.isErrorPage = false;
      }
      else if (routingUrl != '/' && routingUrl.startsWith('/error')) {
        this.isErrorPage = true;
        this.loadingService.ShowLoading.next(false);
      }
      this.userAuth();
    });
    this.loadingClass = "";
    //let ua = window.navigator.userAgent.toLowerCase();
    //if (!(ua.indexOf('macintosh') > -1 && ua.indexOf('safari') > -1)) {
    //  this.detectMultipleTabs();
    //}
    try {
      this.detectMultipleTabs();
    }
    catch {
      console.error("BroadcastChannel not supported by this browser");
    }
  }

  private closePopups(url: string): void {
    let closeCheck = this.utilityService.shouldClosePopups(url, this.previousUrl);
    if (closeCheck) {
      document.querySelectorAll("kendo-dialog .k-i-x, kendo-window .k-i-x").forEach((x: HTMLElement) => x.click());
    }
    this.previousUrl = url;
  }

  private userAuth() {
    this.authservice.isAuthenticated().subscribe(auth => {
      this.userIsAuthenticated = auth;
      if (auth) {
        this.lookupService.GetUserView().subscribe(x => {
          this.userView = x;
        });
      }
    });
  }

  public topMenuClick(e) {
    let path = this.activatedRoute.snapshot.queryParams['aspxpath'];
    if ((e.target && e.target.href && !e.target.relList.contains("noopener"))) {
      this.loadingService.ShowLoading.next(e.target.href != path);
      e.preventDefault();
      this.router.navigate(['/page'], {
        queryParams: { aspxpath: e.target.href }
      });

      //  this.appLoadingRef.nativeElement.removeAttribute("style");
    }
    else if (e.item && e.item.url) {
      if (this.router.url.includes(e.item.url)) {
        e.preventDefault();
        return;
      }
      this.loadingService.ShowLoading.next(e.item.url != path);
      e.preventDefault();
      if (e.item.url.startsWith(this.WebAppName)) {
        this.router.navigate(['/page'], {
          queryParams: { aspxpath: e.item.url }
        });
      }
      else {
        this.router.navigate([`/${e.item.url}`]);
      }
    }
  }

  private detectMultipleTabs() {
    if (window.name.length < 1) {
      window.name = `${AppConstants.COLLABAPP_NAME}${Date.now().toString()}`;
    }
    let bc: BroadcastChannel = new BroadcastChannel('collabBroadcastChannel');
    bc.postMessage({ subject: 'bcMessage1', windowId: window.name });
    bc.onmessage = (m) => {
      const safeTabKey = 'qsmcollaborateSafeTab';
      if (m.data.subject == 'bcMessage1') {
        bc.postMessage({ subject: 'bcMessage2', windowId: window.name });
        sessionStorage.setItem(safeTabKey, this.id);
      }
      if (m.data.subject == 'bcMessage2' && sessionStorage.getItem(safeTabKey) == null) {
        const errorMsg = "The application is open in another window or tab. Please close this and return to the other window or tab.";
        this.accessAllowed = false;
        this.router.navigate(['/page'], {
          queryParams: { aspxpath: `/${AppConstants.WEBAPP_NAME}/AccessDenied.aspx?Reason=${errorMsg}&HidePrivilegeMessage=true&id=${this.id}` }
        })
      }
    };
  }

  public get showBackOffice(): boolean {
    return this.userView.roleInfo.IsBackOffice || this.userView.roleInfo.IsEstimateExpert || this.userView.roleInfo.IsCloseoutExpert;
  }

  public get showBackOfficeItems(): boolean {
    return this.userView.roleInfo.IsBackOffice;
  }

  public get showImportCloseout(): boolean {
    return this.userView.roleInfo.IsCloseoutExpert;
  }

  public get showImportEstimate(): boolean {
    return this.userView.roleInfo.IsEstimateExpert;
  }

  public showPrivacyPolicy() {
    let url: string = this.WebAppName + "/Account/privacy.aspx?iFrameCollab=true";
    this.aspxIframeSrcApp = this.sanitizer.bypassSecurityTrustResourceUrl(url);
    this.aspxIframeHeight = 600;
    this.aspxIframeWidth = 810;
    this.openAspxIFrame = this.dialogService.open({
      title: 'Privacy Policy',
      content: this.windowContents,
      height: 550,
      width: 800,
      cssClass: 'overflow-hidden'
    });
  }
}
